<template>
  <div class="service-info">
    <div class="label">
      <h1>西安星年物联网科技有限公司的服务范围</h1>
      <h5>Our range of services</h5>
    </div>
    <div class="service-introduce">
      <p>
        西安星年物联网科技有限公司是一家以水表、热表，电表，气表产品模块及解决方案为主的集开发、设计、生产和销售为一体的国家高新物联网技术企业，致力于为客户提供完善可靠行业领先的物联网产品应用解决方案。
      </p>
    </div>
    <!-- <el-row :gutter="16">
      <el-col :span="6">
        <div>
          <img src="@/svg/money.svg" />
        </div>
      </el-col>
      <el-col :span="6"></el-col>
      <el-col :span="6"></el-col>
      <el-col :span="6"></el-col>
    </el-row>-->
    <div class="service-ele">
      <div class="ele-iem">
        <div class="ele-img">
          <img src="@/svg/money.svg" />
        </div>
        <div class="ele-label">
          <p>价格透明化</p>
        </div>
      </div>
      <div class="ele-iem">
        <div class="ele-img">
          <img src="@/svg/safe.svg" />
        </div>
        <div class="ele-label">
          <p>品质保证</p>
        </div>
      </div>
      <div class="ele-iem">
        <div class="ele-img">
          <img src="@/svg/technology.svg" />
        </div>
        <div class="ele-label">
          <p>技术先进</p>
        </div>
      </div>
      <div class="ele-iem">
        <div class="ele-img">
          <img src="@/svg/after.svg" />
        </div>
        <div class="ele-label">
          <p>专业售后</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
.service-info {
  .label {
    text-align: center;
    h1 {
      color: #4e56c5;
    }
    h5 {
      color: #4e56c5;
    }
  }
  .service-introduce {
    width: 36%;
    margin: 0 auto;
    padding: 12px 0 8px 0;
  }
  .service-ele {
    margin: 0 auto;
    width: 50%;
    display: flex;
    .ele-iem {
      margin-left: 40px;
      width: 25%;
      // padding: 12px;
      .ele-img img {
        width: 100px;
        height: 100px;
      }
      .ele-label {
        margin-left: 10px;
      }
    }
  }
}
</style>
